import React, { Fragment, useState, useEffect } from "react";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import InputBase from "@material-ui/core/InputBase";

// Material-UI Icon
import SearchIcon from "@material-ui/icons/Search";

// Custom Style
import { transferListStyle } from "../../styles/jss/components/transferList/transferListStyle";

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const useStyles = makeStyles((theme) => transferListStyle(theme));

const RFITransferList = (props) => {
  const classes = useStyles();
  const {
    recipientType,
    reciptentChipAdd,
    reciptentChipRemove,
    listData,
    userType,

    leftToUserRcpt,
    setLeftToUserRcpt,
    rightToUserRcpt,
    setRightToUserRcpt,

    leftToExternalUserRcpt,
    setLeftToExternalUserRcpt,
    rightToExternalUserRcpt,
    setRightToExternalUserRcpt,

    leftCcUserRcpt,
    setLeftCcUserRcpt,
    rightCcUserRcpt,
    setRightCcUserRcpt,

    leftResponsibleUserRcpt,
    setLeftResponsibleUserRcpt,
    rightResponsibleUserRcpt,
    setRightResponsibleUserRcpt,

    leftApproveUserRcpt,
    setLeftApproveUserRcpt,
    rightApproveUserRcpt,
    setRightApproveUserRcpt,

    leftSecondApproveUserRcpt,
    setLeftSecondApproveUserRcpt,
    rightSecondApproveUserRcpt,
    setRightSecondApproveUserRcpt,

    leftThirdApproveUserRcpt,
    setLeftThirdApproveUserRcpt,
    rightThirdApproveUserRcpt,
    setRightThirdApproveUserRcpt,

    leftConsultantUserRcpt,
    setLeftConsultantUserRcpt,
    rightConsultantUserRcpt,
    setRightConsultantUserRcpt,

    leftArchitectUserRcpt,
    setLeftArchitectUserRcpt,
    rightArchitectUserRcpt,
    setRightArchitectUserRcpt,

    leftPMUserRcpt,
    setLeftPMUserRcpt,
    rightPMUserRcpt,
    setRightPMUserRcpt,
  } = props;

  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);

  let leftChecked = intersection(checked, listData);

  let rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const saveRcptData = async (leftList, rightList, userType) => {
    let right = rightList.map((obj) => ({
      ...obj,
      userType: userType,
    }));
    if (recipientType === "TO") {
      setRightToUserRcpt(
        rightToUserRcpt === null
          ? right
          : right.concat(
              rightToUserRcpt.filter((item) => item.userType !== userType)
            )
      );
      setLeftToUserRcpt(leftList);
    } else if (recipientType === "CC") {
      setRightCcUserRcpt(
        rightCcUserRcpt === null
          ? right
          : right.concat(
              rightCcUserRcpt.filter((item) => item.userType !== userType)
            )
      );
      setLeftCcUserRcpt(leftList);
    } else if (recipientType === "PM") {
      setRightPMUserRcpt(
        rightPMUserRcpt === null
          ? right
          : right.concat(
              rightPMUserRcpt.filter((item) => item.userType !== userType)
            )
      );
      setLeftPMUserRcpt(leftList);
    } else if (recipientType === "RESPONSIBLE") {
      setRightResponsibleUserRcpt(
        rightResponsibleUserRcpt === null
          ? right
          : right.concat(
              rightResponsibleUserRcpt.filter(
                (item) => item.userType !== userType
              )
            )
      );
      setLeftResponsibleUserRcpt(leftList);
    } else if (recipientType === "ARCHITECT") {
      setRightArchitectUserRcpt(
        rightArchitectUserRcpt === null
          ? right
          : right.concat(
              rightArchitectUserRcpt.filter(
                (item) => item.userType !== userType
              )
            )
      );
      setLeftArchitectUserRcpt(leftList);
    } else if (recipientType === "CONSULTANT") {
      setRightConsultantUserRcpt(
        rightConsultantUserRcpt === null
          ? right
          : right.concat(
              rightConsultantUserRcpt.filter(
                (item) => item.userType !== userType
              )
            )
      );
      setLeftConsultantUserRcpt(leftList);
    } else if (recipientType === "APPROVE") {
      setRightApproveUserRcpt(
        rightApproveUserRcpt === null
          ? right
          : right.concat(
              rightApproveUserRcpt.filter((item) => item.userType !== userType)
            )
      );
      setLeftApproveUserRcpt(leftList);
    } else if (recipientType === "SECONDAPPROVER") {
      setRightSecondApproveUserRcpt(
        rightSecondApproveUserRcpt === null
          ? right
          : right.concat(
              rightSecondApproveUserRcpt.filter(
                (item) => item.userType !== userType
              )
            )
      );
      setLeftSecondApproveUserRcpt(leftList);
    } else if (recipientType === "THIRDAPPROVER") {
      setRightThirdApproveUserRcpt(
        rightThirdApproveUserRcpt === null
          ? right
          : right.concat(
              rightThirdApproveUserRcpt.filter(
                (item) => item.userType !== userType
              )
            )
      );
      setLeftThirdApproveUserRcpt(leftList);
    } else if (recipientType === "TOEXTERNAL") {
      setRightToExternalUserRcpt(
        rightToExternalUserRcpt === null
          ? right
          : right.concat(
              rightToExternalUserRcpt.filter(
                (item) => item.userType !== userType
              )
            )
      );
      setLeftToExternalUserRcpt(leftList);
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));

    saveRcptData(
      not(left, leftChecked),
      right.concat(leftChecked),
      userType
    ).then(() => {
      reciptentChipAdd("USER", leftChecked);
    });
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));

    saveRcptData(
      left.concat(rightChecked),
      not(right, rightChecked),
      userType
    ).then(() => {
      reciptentChipRemove("USER", rightChecked);
    });
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ "aria-label": "all items selected" }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />

      <Divider />

      <List className={classes.list} dense component="div" role="list">
        {items &&
          items.map((res) => {
            const labelId = `transfer-list-all-item-${res.user_seq}-label`;

            return (
              <ListItem
                key={res.user_seq}
                role="listitem"
                button
                // onClick={handleToggle(res)}
              >
                <ListItemIcon>
                  <Checkbox
                    onClick={handleToggle(res)}
                    checked={checked.indexOf(res) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ListItemIcon>

                <ListItemText
                  id={labelId}
                  primary={res.fullname}
                  secondary={res.company.company_name}
                />
              </ListItem>
            );
          })}
      </List>
    </Card>
  );

  const returnRecipientAfterAction = (rightUser, listOfUser) => {
    let rightArr = [];

    if (rightUser && rightUser.length > 0) {
      for (var i = 0; i < rightUser.length; i++) {
        rightArr.push(rightUser[i].site_user_seq);
      }
    }
    let internalList = listOfUser;
    internalList = listOfUser.filter(
      (obj) => !rightArr.includes(obj.site_user_seq)
    );
    return internalList;
  };

  const quickSearch = (event) => {
    const keyWord = event.target.value !== null ? event.target.value : "";
    let filterResult = "";
    if (recipientType === "TO") {
      let internalList = returnRecipientAfterAction(rightToUserRcpt, listData);
      filterResult = internalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "RESPONSIBLE") {
      let internalList = returnRecipientAfterAction(
        rightResponsibleUserRcpt,
        listData
      );
      filterResult = internalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "APPROVE") {
      let internalList = returnRecipientAfterAction(
        rightApproveUserRcpt,
        listData
      );
      filterResult = internalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "PM") {
      let internalList = returnRecipientAfterAction(rightPMUserRcpt, listData);
      filterResult = internalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "SECONDAPPROVER") {
      let internalList = returnRecipientAfterAction(
        rightSecondApproveUserRcpt,
        listData
      );
      filterResult = internalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "THIRDAPPROVER") {
      let internalList = returnRecipientAfterAction(
        rightThirdApproveUserRcpt,
        listData
      );
      filterResult = internalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "CONSULTANT") {
      let externalList = returnRecipientAfterAction(
        rightConsultantUserRcpt,
        listData
      );
      filterResult = externalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "ARCHITECT") {
      let externalList = returnRecipientAfterAction(
        rightArchitectUserRcpt,
        listData
      );
      filterResult = externalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "TOEXTERNAL") {
      let externalList = returnRecipientAfterAction(
        rightToExternalUserRcpt,
        listData
      );
      filterResult = externalList.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    } else if (recipientType === "CC") {
      let List = returnRecipientAfterAction(rightCcUserRcpt, listData);
      filterResult = List.filter((item) =>
        item.fullname.toLowerCase().includes(keyWord.toLowerCase())
      );
    }
    setLeft(filterResult);
  };

  useEffect(() => {
    if (recipientType === "TO") {
      let internalList = returnRecipientAfterAction(rightToUserRcpt, listData);
      leftToUserRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftToUserRcpt);
      rightToUserRcpt === null
        ? setRight([])
        : setRight(
            rightToUserRcpt.filter((item) => item.userType === userType)
          );
    } else if (recipientType === "CC") {
      let List = returnRecipientAfterAction(rightCcUserRcpt, listData);
      leftCcUserRcpt === null || [] ? setLeft(List) : setLeft(leftCcUserRcpt);
      rightCcUserRcpt === null
        ? setRight([])
        : setRight(
            rightCcUserRcpt.filter((item) => item.userType === userType)
          );
    } else if (recipientType === "PM") {
      let List = returnRecipientAfterAction(rightPMUserRcpt, listData);
      leftPMUserRcpt === null || [] ? setLeft(List) : setLeft(leftPMUserRcpt);
      rightPMUserRcpt === null
        ? setRight([])
        : setRight(
            rightPMUserRcpt.filter((item) => item.userType === userType)
          );
    } else if (recipientType === "RESPONSIBLE") {
      let internalList = returnRecipientAfterAction(
        rightResponsibleUserRcpt,
        listData
      );
      leftResponsibleUserRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftResponsibleUserRcpt);
      rightResponsibleUserRcpt === null
        ? setRight([])
        : setRight(
            rightResponsibleUserRcpt.filter(
              (item) => item.userType === userType
            )
          );
    } else if (recipientType === "APPROVE") {
      let internalList = returnRecipientAfterAction(
        rightApproveUserRcpt,
        listData
      );
      leftApproveUserRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftApproveUserRcpt);
      rightApproveUserRcpt === null
        ? setRight([])
        : setRight(
            rightApproveUserRcpt.filter((item) => item.userType === userType)
          );
    } else if (recipientType === "SECONDAPPROVER") {
      let internalList = returnRecipientAfterAction(
        rightSecondApproveUserRcpt,
        listData
      );
      leftSecondApproveUserRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftSecondApproveUserRcpt);
      rightSecondApproveUserRcpt === null
        ? setRight([])
        : setRight(
            rightSecondApproveUserRcpt.filter(
              (item) => item.userType === userType
            )
          );
    } else if (recipientType === "THIRDAPPROVER") {
      let internalList = returnRecipientAfterAction(
        rightThirdApproveUserRcpt,
        listData
      );
      leftThirdApproveUserRcpt === null || []
        ? setLeft(internalList)
        : setLeft(leftThirdApproveUserRcpt);
      rightThirdApproveUserRcpt === null
        ? setRight([])
        : setRight(
            rightThirdApproveUserRcpt.filter(
              (item) => item.userType === userType
            )
          );
    } else if (recipientType === "CONSULTANT") {
      let externalList = returnRecipientAfterAction(
        rightConsultantUserRcpt,
        listData
      );
      leftConsultantUserRcpt === null || []
        ? setLeft(externalList)
        : setLeft(leftConsultantUserRcpt);
      rightConsultantUserRcpt === null
        ? setRight([])
        : setRight(
            rightConsultantUserRcpt.filter((item) => item.userType === userType)
          );
    } else if (recipientType === "ARCHITECT") {
      let externalList = returnRecipientAfterAction(
        rightArchitectUserRcpt,
        listData
      );
      leftArchitectUserRcpt === null || []
        ? setLeft(externalList)
        : setLeft(leftArchitectUserRcpt);
      rightArchitectUserRcpt === null
        ? setRight([])
        : setRight(
            rightArchitectUserRcpt.filter((item) => item.userType === userType)
          );
    } else if (recipientType === "TOEXTERNAL") {
      let externalList = returnRecipientAfterAction(
        rightToExternalUserRcpt,
        listData
      );
      leftToExternalUserRcpt === null || []
        ? setLeft(externalList)
        : setLeft(leftToExternalUserRcpt);
      rightToExternalUserRcpt === null
        ? setRight([])
        : setRight(
            rightToExternalUserRcpt.filter((item) => item.userType === userType)
          );
    } else {
      setLeft([]);
      setRight([]);
    }
  }, []);

  return (
    <Fragment>
      <>
        <div className={classes.searchBar}>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>

            <InputBase
              onChange={quickSearch}
              placeholder="Quick Search"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ "aria-label": "search" }}
            />
          </div>
        </div>
        <Grid
          container
          spacing={2}
          justify="center"
          alignItems="center"
          className={classes.root}
        >
          <Grid item xs={5} md={5}>
            {customList("Choices", left)}
          </Grid>

          <Grid item xs={2} md={2}>
            <Grid container direction="column" alignItems="center">
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleCheckedRight}
                disabled={leftChecked.length === 0}
                aria-label="move selected right"
              >
                &gt;
              </Button>

              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleCheckedLeft}
                disabled={rightChecked.length === 0}
                aria-label="move selected left"
              >
                &lt;
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={5} md={5}>
            {customList("Chosen", right)}
          </Grid>
        </Grid>
      </>
    </Fragment>
  );
};

export default RFITransferList;
